module.exports = __webpack_public_path__ + "media/images/flags/32/Antarctica-e95d51609cd26398c8459c225d751077.png";